module.exports = __webpack_public_path__ + "static/ybflicks-d9632e304f18e76b063b0ba132790e96.png";